<template>
  <div class="area-selector j-area-dcount" @click="handleAreaConfirmPopup">
    {{ curLocation || letter.areaLimitSwitchRegion }}
    <Icon class="area-icon" name="down" />
  </div>
</template>

<script>
import { mapState } from 'vuex';
export default {
  name: 'SelectArea',
  emits: ['handleAreaConfirmPopup'],
  props: {
    curLocation: {
      type: String,
      default: ''
    }
  },
  computed: {
    ...mapState({
      letter: state => state.letter
    })
  },
  methods: {
    handleAreaConfirmPopup() {
      this.$emit('handleAreaConfirmPopup');
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@assets/scss/officialTopupNew/_dimen.scss';

.area-selector {
  @include g-border();
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  height: 50px;
  padding: 0 15px;
  background: #fff;
  border-radius: 10px;
  font-size: 24px;
  color: #333;
  cursor: pointer;

  .area-icon {
    width: 26px;
    height: 26px;
  }
}

#ssr-page.landscape {
  .area-selector {
    font-size: 18px;
    height: 44px;
  }
}
</style>
